import React from 'react';
import { useParams } from 'react-router-dom';
import { ProjectPanelLayout } from './ProjectPanelLayout';
import { WritingSettings } from './WritingSettings';
import { useLocale } from '../contexts/LocaleContext';
import { PROJECT_SECTION_ICONS } from '../utils/concept-icons';

export const ProjectSettings: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const { t } = useLocale();

  return (
    <ProjectPanelLayout title={t('project_settings') || 'Project settings'} titleIcon={PROJECT_SECTION_ICONS.settings}>
      <WritingSettings projectId={projectId || null} onUpdate={() => {}} />
    </ProjectPanelLayout>
  );
};
